import React from 'react';

export default function DateUtcContainer({ data }) {
	return (
		<div>DateUtcContainer</div>
	);
}
